export const linearRegression = (
  data: {
    [key: string]: number;
  }[],
  xKey = "year",
  yKey = "value"
) => {
  const x = data.map((element) => element[xKey]);
  const y = data.map((element) => element[yKey]);
  const sumX = x.reduce((prev, curr) => prev + curr, 0);
  const avgX = sumX / x.length;
  const xDeltasToAvg = x.map((value) => avgX - value);
  const xDeltasToAvgSq = xDeltasToAvg.map((value) => Math.pow(value, 2));
  const sumXX = xDeltasToAvgSq.reduce((prev, curr) => prev + curr, 0);
  const sumY = y.reduce((prev, curr) => prev + curr, 0);
  const avgY = sumY / y.length;
  const yDifferencesToAverage = y.map((value) => avgY - value);
  const xAndYDifferencesMultiplied = xDeltasToAvg.map(
    (curr, index) => curr * yDifferencesToAverage[index]
  );
  const sumXY = xAndYDifferencesMultiplied.reduce(
    (prev, curr) => prev + curr,
    0
  );
  const slope = sumXY / sumXX;
  const intercept = avgY - slope * avgX;

  return (x: number): number => intercept + slope * x;
};
